import { tProvidersProps } from '../LayoutProvider/Layout.types';
import { SocketsContext } from './Sockets.context';
import useSockets from './Sockets.hook';

export function SocketsProvider(props: tProvidersProps) {
  const { children } = props;
  const sockets = useSockets();

  return (
    <SocketsContext.Provider value={sockets}>
      {children}
    </SocketsContext.Provider>
  );
}
